const triangle = {
    init() {
        triangle.create();
    },
    create() {
        const triangle = $("[data-triangle-element]");
        if (!triangle.length) return;

        triangle.each(function(index, el) {
            const $this = $(this);
            $this.css('border-top-width', $this.parents('.drop-wrap').outerHeight() - 10);
            setTimeout(function() {
                $this.css('border-top-width', $this.parents('.drop-wrap').outerHeight() - 10);
            }, 200);
        });

        $(window).resize(function(event) {
            triangle.each(function(index, el) {
                const $this = $(this);
                $this.css('border-top-width', $this.parents('.drop-wrap').outerHeight() - 10);
                setTimeout(function() {
                    $this.css('border-top-width', $this.parents('.drop-wrap').outerHeight() - 10);
                }, 200);
            });
        });

        $('body').on('click', '[data-dropdown-element]', function(event) {
            setTimeout(function () {
                triangle.each(function(index, el) {
                    const $this = $(this);
                    $this.css('border-top-width', $this.parents('.drop-wrap').outerHeight() - 10);
                    setTimeout(function() {
                        $this.css('border-top-width', $this.parents('.drop-wrap').outerHeight() - 10);
                    }, 200);
                });
            }, 500);
        });
    }
};

$(function() {
    triangle.init();
});